import React from 'react';
import './PaginationButton.scss';

const PaginationButton = ({ page, totalPages, onChange }) => {
  const getPaginationNumbers = () => {
    const first = 0;
    const last = totalPages - 1;
    const pages = [];

    const current = page;

    pages.push(first);

    // If total pages small → show everything
    if (totalPages <= 7) {
      for (let i = 1; i <= last; i++) pages.push(i);
      return pages;
    }

    // --- CASE 1: Near start ---
    if (current <= 2) {
      pages.push(1, 2, 3, 4);
      pages.push('ellipsis');
      pages.push(last);
      return pages;
    }

    // --- CASE 2: Near end ---
    if (current >= last - 2) {
      pages.push('ellipsis');
      pages.push(last - 4, last - 3, last - 2, last - 1);
      pages.push(last);
      return pages;
    }

    // --- CASE 3: Middle ---
    pages.push('ellipsis');
    pages.push(current - 1, current, current + 1);
    pages.push('ellipsis');
    pages.push(last);

    return pages;
  };

  const paginationNumbers = getPaginationNumbers();

  return (
    <div className="pagination-button">
      {/* Prev Arrow */}
      <button
        className="pagination-button__arrow"
        disabled={page === 0}
        onClick={() => onChange(page - 1)}
      >
        &lt;
      </button>

      {/* Page Numbers */}
      {paginationNumbers.map((num, idx) => {
        if (num === 'ellipsis') {
          return (
            <span
              // eslint-disable-next-line react/no-array-index-key
              key={`ellipsis-${idx}`}
              className="pagination-button__ellipsis"
            >
              …
            </span>
          );
        }

        return (
          <button
            key={`page-${num}`}
            className={`pagination-button__number ${
              page === num ? 'active' : ''
            }`}
            onClick={() => onChange(num)}
          >
            {num + 1}
          </button>
        );
      })}

      {/* Next Arrow */}
      <button
        className="pagination-button__arrow"
        disabled={page === totalPages - 1}
        onClick={() => onChange(page + 1)}
      >
        &gt;
      </button>
    </div>
  );
};

export default PaginationButton;
